<template>
  <van-overlay :show="isShow" z-index="10000">
    <div class="wrapper" @click.stop>
      <van-loading size="24px" vertical>{{ text }}</van-loading>
    </div>
  </van-overlay>
</template>
<script>
import { reactive, toRefs } from 'vue'
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '数据加载中...'
    }
  },
  emits: ['click', 'clickBtn'],
  setup(props, { emit }) {
    let { isShow, text } = toRefs(props)
    const state = reactive({
      isShow,
      text
    })
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
